module.exports = __webpack_public_path__ + "img/rocket.1591ee69.png";